// トップページのjs

import "../sass/page-top.scss";

import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";
import ScrollHint from "scroll-hint";
import "scroll-hint/css/scroll-hint.css";

import { celebrate } from "../jsmodules/celebrate";

const scrollbarFn = () => {
	const targets = document.querySelectorAll(".js-sb");
	if (targets.length === 0) return;

	// prettier-ignore
	Array.prototype.forEach.call(
		targets,
		(target) => new SimpleBar(target, {
				autoHide: false,
				scrollbarMaxSize: 150,
			}),
	);
};

/**
 * 横スクロールできることを示すヒント。
 * SimpleBar が作る実際のスクロール面（.simplebar-content-wrapper）に付ける。
 */
const scrollHintFn = () => {
	const targets = document.querySelectorAll(".js-scrollable");
	if (targets.length === 0) return;

	const items = [...targets].map((el) => el.querySelector(".simplebar-content-wrapper") || el);

	// 副作用のための初期化。インスタンスは保持しない。
	// eslint-disable-next-line no-new
	new ScrollHint(items, {
		scrollHintIconAppendClass: "scroll-hint-icon-white",
		i18n: {
			scrollable: "スクロールできます",
		},
	});
};

document.addEventListener("DOMContentLoaded", () => {
	scrollbarFn();
	scrollHintFn();
});

window.addEventListener("load", () => {
	// メインビジュアルが見えてから紙吹雪を舞わせる
	setTimeout(celebrate, 600);
});
